//
// The Yoast FAQ specific JavaScript
//

const faqBlock = document.getElementsByClassName('wp-block-yoast-faq-block');
if (faqBlock.length !== 0) {
	const allQuestions = document.querySelectorAll('.wp-block-yoast-faq-block .schema-faq-section');

	allQuestions.forEach(question => {
		question.querySelector('.schema-faq-question').addEventListener('click', function () {
			const parent = this.parentElement;
			if (parent.classList.contains('open')) {
				parent.classList.remove('open');
			} else {
				allQuestions.forEach(question => {
					question.classList.remove('open');
				});
				parent.classList.add('open');
			}
		});
	});
}

//
// Custom FAQ block accordion with animated open/close
//

(function () {
	const allDetails = document.querySelectorAll('.faq-list-block__details');

	if (!allDetails.length) return;

	/**
	 * Animate a <details> element open.
	 */
	function animateOpen(details, content) {
		details.open = true;
		content.style.overflow = 'hidden';
		content.style.height = '0px';
		content.style.opacity = '0';

		// Force reflow so the browser registers the start values
		content.getBoundingClientRect();

		content.style.transition = 'height 0.3s ease, opacity 0.3s ease';
		content.style.height = content.scrollHeight + 'px';
		content.style.opacity = '1';

		content.addEventListener('transitionend', function handler(e) {
			if (e.propertyName !== 'height') return;
			// Clean up inline styles so CSS can take over normally
			content.style.cssText = '';
			content.removeEventListener('transitionend', handler);
		});
	}

	/**
	 * Animate a <details> element closed.
	 */
	function animateClose(details, content) {
		content.style.overflow = 'hidden';
		content.style.height = content.scrollHeight + 'px';
		content.style.opacity = '1';

		// Force reflow
		content.getBoundingClientRect();

		content.style.transition = 'height 0.3s ease, opacity 0.3s ease';
		content.style.height = '0px';
		content.style.opacity = '0';

		content.addEventListener('transitionend', function handler(e) {
			if (e.propertyName !== 'height') return;
			details.open = false;
			content.style.cssText = '';
			content.removeEventListener('transitionend', handler);
		});
	}

	allDetails.forEach(function (details) {
		const summary = details.querySelector('.faq-list-block__summary');
		const answer  = details.querySelector('.faq-list-block__answer');

		if (!summary || !answer) return;

		summary.addEventListener('click', function (e) {
			e.preventDefault();

			if (details.open) {
				animateClose(details, answer);
			} else {
				// Close all sibling details first
				allDetails.forEach(function (other) {
					if (other !== details && other.open) {
						animateClose(other, other.querySelector('.faq-list-block__answer'));
					}
				});
				animateOpen(details, answer);
			}
		});
	});
}());

